import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = {
  class: "offcanvas offcanvas-start bg-light",
  tabindex: "-1",
  id: "offcanvasNavbar",
  "aria-labelledby": "offcanvasNavbarLabel"
}
const _hoisted_3 = { class: "offcanvas-header" }
const _hoisted_4 = { class: "offcanvas-body" }
const _hoisted_5 = { class: "navbar-nav ms-auto mb-2 mb-lg-0 align-items-center accordion" }
const _hoisted_6 = { class: "list-unstyled" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]

import { ref, computed, onMounted } from 'vue';
import { Offcanvas } from 'bootstrap';
import MobileAccordionItem from './MobileAccordionItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileNavbar',
  props: {
  isScrolled: Boolean,
  homeServices: Array,
  specialistServices: Array,
},
  emits: ['homeScroll'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const openIndex = ref<number | null>(null);

const accordionItems = computed(() => [
  {
    id: 'what-we-do',
    title: 'Our services',
    links: props.homeServices?.map((s: any) => ({
      text: s.displayText,
      to: s.path
    })) || [],
    //viewAllLink: '/services'
  },
  {
    id: 'specialist-divisions',
    title: 'Specialist Divisions',
    links: props.specialistServices?.map((s: any) => ({
      text: s.displayText,
      to: s.path
    })) || [],
    //viewAllLink: '/specialist-divisions'
  }
]);

function toggleAccordion(index: number) {
  openIndex.value = openIndex.value === index ? null : index;
}

onMounted(() => {
  const offcanvasElement = document.getElementById('offcanvasNavbar');
  if (offcanvasElement) {
    new Offcanvas(offcanvasElement);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["navbar navbar-expand-lg navbar-sticky sticky py-3", { 'scrolled': props.isScrolled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "navbar-brand logo-style",
        to: "/",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('homeScroll')))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "text-primary" }, "/", -1),
          _createElementVNode("span", { class: "text-secondary" }, "/", -1),
          _createElementVNode("span", { class: "text-tertiary" }, "/", -1),
          _createTextVNode(" nologo studios ", -1)
        ]))]),
        _: 1
      }),
      _cache[7] || (_cache[7] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "offcanvas",
        "data-bs-target": "#offcanvasNavbar",
        "aria-controls": "offcanvasNavbar",
        "aria-label": "Toggle navigation"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "offcanvas-title logo-style",
            href: "/",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('homeScroll'))),
            id: "offcanvasNavbarLabel"
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", { class: "text-primary" }, "/", -1),
            _createElementVNode("span", { class: "text-secondary" }, "/", -1),
            _createElementVNode("span", { class: "text-tertiary" }, "/", -1),
            _createTextVNode(" nologo studios ", -1)
          ]))]),
          _cache[4] || (_cache[4] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "offcanvas",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accordionItems.value, (item, index) => {
              return (_openBlock(), _createBlock(MobileAccordionItem, {
                key: item.id,
                title: item.title,
                isOpen: openIndex.value === index,
                onToggle: ($event: any) => (toggleAccordion(index))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (link) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: link.to
                      }, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          href: link.to
                        }, _toDisplayString(link.text), 9, _hoisted_7)
                      ]))
                    }), 128)),
                    (item.viewAllLink)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                          _createElementVNode("a", {
                            class: "nav-link",
                            href: item.viewAllLink
                          }, " View all ", 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["title", "isOpen", "onToggle"]))
            }), 128)),
            _cache[5] || (_cache[5] = _createStaticVNode("<li class=\"nav-item\" data-v-366eb805><a class=\"nav-link\" href=\"/about-us\" data-v-366eb805>About</a></li><li class=\"nav-item\" data-v-366eb805><a class=\"nav-link\" href=\"/careers\" data-v-366eb805>Careers</a></li><li class=\"nav-item\" data-v-366eb805><a href=\"/contact\" class=\"btn btn-primary text-white text-center py-2 px-4\" data-v-366eb805> Get in touch </a></li>", 3))
          ])
        ]),
        _cache[6] || (_cache[6] = _createStaticVNode("<hr class=\"mt-0\" data-v-366eb805><div class=\"nav-item flex justify-content-center py-2 text-center\" data-v-366eb805><a href=\"https://za.linkedin.com/company/nologo-studios\" target=\"_blank\" data-v-366eb805><i class=\"fa-brands fa-linkedin-in h1 mx-2\" data-v-366eb805></i></a><a href=\"https://www.facebook.com/nologostudios/\" target=\"_blank\" data-v-366eb805><i class=\"fa-brands fa-facebook h1 mx-2\" data-v-366eb805></i></a><a href=\"tel:+27312660245\" data-v-366eb805><i class=\"fa-solid fa-phone h2 fw-bold mx-2\" data-v-366eb805></i></a><a href=\"mailto:info@nologostudios.com\" data-v-366eb805><i class=\"fas fa-envelope h2 fw-bold mx-2\" data-v-366eb805></i></a></div>", 2))
      ])
    ])
  ], 2))
}
}

})